import Modal from 'components/Modal'
import LoyaltyAllocationTx from 'views/MemberProfile/ManualTx/LoyaltyAllocationTx'

type Props = {
  title: string | undefined
  open: boolean
  onClose: () => void
}

const ModalLoyaltyAllocationTx = ({
  title,
  open,
  onClose,
}: Props): JSX.Element => {
  return (
    <Modal open={open} title={title} onClose={onClose} noFooter>
      <LoyaltyAllocationTx onClose={onClose} />
    </Modal>
  )
}

export default ModalLoyaltyAllocationTx
